<div bsModal #RcopiaPopUp="bs-modal" class="modal fade rcopia-modal" tabindex="-1" role="dialog" 
     aria-labelledby="RcopiaPopUp" aria-hidden="true" 
     [config]="{backdrop: false, keyboard: true}">
    <div class="modal-dialog modal-xl" [style.width.px]="screenWidth">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="fas fa-prescription-bottle-alt me-2"></i>
                    Rcopia
                </h5>
                <button type="button" 
                        class="btn btn-icon btn-sm btn-active-light-primary ms-2" 
                        (click)="RcopiaClose()" 
                        [disabled]="saving || isLoading"
                        aria-label="Close">
                    <i class="ki-duotone ki-cross fs-2">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </button>
            </div>
            
            <div *ngIf="isLoading" 
                 class="modal-body p-0 d-flex align-items-center justify-content-center" 
                 [style.height.px]="modalheight">
                <div class="text-center">
                    <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="text-muted">Connecting to Rcopia...</p>
                </div>
            </div>
            
            <div *ngIf="!isLoading && showFrame" 
                 class="modal-body p-0" 
                 [style.height.px]="modalheight">
            </div>
        </div>
    </div>
</div>